<div class="loading-screen">
  <mat-progress-spinner diameter="75" mode="indeterminate" class="d-inline-block"></mat-progress-spinner>
  <h2>{{ title }}...</h2>
  <h3>{{ description }}</h3>
</div>
